import { render } from "./Modal.vue?vue&type=template&id=914300da"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"
script.render = render

export default script